import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import firebase from 'firebase/app';
require("firebase/firestore");

const styles = theme => ({
});

class VoidTransactionDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      processing: false,

      deskTransaction: null,
    };
  }

  handleSubmit = () => {
    if (this.state.deskTransaction) {
      this.startProcessing();

      this.submitVoidTransaction()
        .then(this.handleRequestClose)
        .then(this.stopProcessing);
    }
  }

  submitVoidTransaction = () => {
    return firebase.firestore()
      .collection('deskTransaction')
      .doc(this.state.deskTransaction.id)
      .get()
      .then(doc => {
        let deskTransaction = doc.data();

        let pDesk = firebase.firestore()
          .collection('deskTransaction')
          .doc(doc.id)
          .update({ voided: true, });

        let pPass;
        if (deskTransaction.passTransactionId) {
          pPass = firebase.firestore()
            .collection('passTransaction')
            .doc(deskTransaction.passTransactionId)
            .update({
              voided: true,
            });
        } else {
          pPass = Promise.resolve();
        }

        return Promise.all([pDesk, pPass]);
      });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({ open: nextProps.open, });
    }
    if (nextProps.deskTransaction) {
      this.setState({ deskTransaction: nextProps.deskTransaction, });
    }
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleRequestClose} >
          <DialogTitle>Are you sure to void this transaction?</DialogTitle>

          <DialogContent>
            {this.state.deskTransaction && this.state.deskTransaction.id}
          </DialogContent>

          <DialogActions>
            <Button
              disabled={this.state.processing}
              onClick={this.handleRequestClose} >
              CLOSE
            </Button>
            <Button
              disabled={ this.state.processing || !this.state.deskTransaction || this.state.processing }
              onClick={this.handleSubmit}
              color="primary" >
              VOID
            </Button>
          </DialogActions>

        </Dialog>
      </div>
    );
  }
}

VoidTransactionDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  deskTransaction: PropTypes.object,
};

export default withStyles(styles)(VoidTransactionDialog);
